export default __webpack_public_path__ + "static/media/logo.31bf65e4.png";